export interface FAQ {
  question: string;
  answer: string;
}

export const faqs: FAQ[] = [
  {
    question: "What do I need to use a Bitcoin ATM?",
    answer: "A valid government-issued ID and a Bitcoin wallet on your phone. We recommend downloading a Bitcoin wallet before visiting."
  },
  {
    question: "What are your transaction limits and requirements?",
    answer: "We operate on a tiered system:\n- $0 – $499: No information needed\n- $500 – $999: SMS verification required\n- $1,000 – $9,999: ID, SMS verification, and personal information required\n- $10,000+: ID, SMS verification, SSN, and personal information required\nThese apply to daily and weekly limits."
  },
  {
    question: "How long do transactions take?",
    answer: "Most transactions complete within minutes. During high network traffic, confirmations may take up to 30 minutes. You can track status through your Bitcoin wallet."
  },
  {
    question: "What cryptocurrencies do you support?",
    answer: "Currently, we only offer Bitcoin transactions. We may expand to other cryptocurrencies as regulations permit."
  },
  {
    question: "What if I need help with my transaction?",
    answer: "Contact our support team via phone, text, or email - contact information is displayed on each BTM. Please include your transaction ID and BTM location when reporting issues."
  },
  {
    question: "Do you offer paper wallets?",
    answer: "While our BTMs can print paper wallets, we recommend using digital wallets for better security and convenience."
  }
];